import { useRequest } from 'ahooks'
import { Form } from 'antd'
import moment from 'moment'
import React from 'react'
import { useHistory } from 'react-router-dom'

import { SpecialProjectLocalStorageModal } from '@/components/special-project-local-storage-modal'
import { routes } from '@/router'
import { SpecialProjectFormLocalStorageKey } from '@/schemas'

import { ProductionForm } from './production-form/production-form.component'
import { Production } from './production.schema'

export const ProductionCreate: React.FC<{ production?: Production }> = () => {
  const history = useHistory()
  const [form] = Form.useForm()
  const { run: onSubmit, loading } = useRequest(
    (data) => ({
      url: '/api/production',
      method: 'post',
      data,
    }),
    {
      manual: true,
      onSuccess: (data: Production) => {
        history.push(routes.production.detail(data.selfId))
      },
    }
  )

  return (
    <>
      <ProductionForm loading={loading} form={form} onSubmit={onSubmit} />
      <SpecialProjectLocalStorageModal
        localStorageKey={SpecialProjectFormLocalStorageKey.PRODUCTION}
        onSetForm={(value) => {
          form.setFieldsValue({
            ...value,
            range: value.range ? [moment(value.range[0]), moment(value.range[1])] : undefined,
            expectDeliveryTime: moment(value.expectDeliveryTime),
            expectProductionTime: moment(value.expectProductionTime),
            expectTargetCheckTime: moment(value.expectTargetCheckTime),
            stageTarget: value.stageTarget?.map((item: any) => ({
              ...item,
              date: moment(item.date),
            })),
            localCacheExpireTime: undefined,
          })
        }}
      />
    </>
  )
}
